import React from 'react';

// 此元件掛在 ConfigProvider 之上，拿不到 antd theme context，
// 故直接讀線上品牌設定（src/data.json）對齊主色與文字色，避免落回 antd 預設藍。
const {colors} = require('../data.json');

/**
 * 全域 React 錯誤邊界。
 * 捕捉到 render error 時不再導頁（移除原本 navigate 到 /404 的邏輯），
 * 改為顯示最簡 fallback UI，讓使用者可重新整理或返回首頁。
 * PostHog SDK 會自動 capture exception。
 */
class GlobalErrorBoundary extends React.Component {
  state = {hasError: false};

  static getDerivedStateFromError() {
    return {hasError: true};
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('[GlobalErrorBoundary]', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          style={{
            minHeight: '60vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 16,
            padding: 24,
            textAlign: 'center',
          }}>
          <p style={{margin: 0, fontSize: 16, color: colors.text}}>
            發生錯誤，請重新整理頁面
          </p>
          <div style={{display: 'flex', gap: 12}}>
            <button
              type="button"
              onClick={() => {
                if (typeof window !== 'undefined') {
                  window.location.reload();
                }
              }}
              style={{
                padding: '8px 20px',
                fontSize: 14,
                lineHeight: '22px',
                cursor: 'pointer',
                border: `1px solid ${colors.borderSecond}`,
                borderRadius: 2,
                background: '#fff',
                color: colors.text,
              }}>
              重新整理
            </button>
            <a
              href="/"
              style={{
                padding: '8px 20px',
                fontSize: 14,
                lineHeight: '22px',
                borderRadius: 2,
                background: colors.main,
                color: '#fff',
                textDecoration: 'none',
                boxShadow: '0 2px 0 rgba(20,165,140,0.1)',
              }}>
              返回首頁
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default GlobalErrorBoundary;
